import { render, staticRenderFns } from "./PriTama01_Nico.vue?vue&type=template&id=1b8ee2aa&scoped=true&"
import script from "./PriTama01_Nico.vue?vue&type=script&lang=js&"
export * from "./PriTama01_Nico.vue?vue&type=script&lang=js&"
import style0 from "./PriTama01_Nico.vue?vue&type=style&index=0&id=1b8ee2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ee2aa",
  null
  
)

export default component.exports